// Constants for GTM events
export const GTM_EVENTS = {
  SCROLL_THRESHOLD: 'scroll',
};
